import { useState, createContext, useContext } from 'react';

const LoadingContext = createContext({});

export const LoadingProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(true);

    const showLoading = () => setIsLoading(true);
    const hideLoading = () => setIsLoading(false);

    return (
        <LoadingContext.Provider value={{ isLoading, showLoading, hideLoading }}>
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => useContext(LoadingContext);